"use client"

import { CircleDot } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CircleDotIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CircleDotIcon = component(Icon)({ as: CircleDot })
